'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _webComponents = require('@vezeeta/web-components');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _enum = require('@vezeeta/enterprise-utils/lib/enum');

var _confirmations = require('../actions/confirmations');

var _confirmations2 = require('../types/confirmations');

var _confirmations3 = _interopRequireDefault(_confirmations2);

var _language = require('../types/language');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  confirmations: _webComponents.renderer.loading(),
  confirmationsList: [],
  list: [],
  isLoading: true,
  isConfirmationSaved: false,
  selectedDoctors: [],
  selectedBranch: {},
  snackBar: { show: false, message: '' },
  saveConfirmationsStatus: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _confirmations.CONFIRMATIONS.FETCH:
      return _extends({
        confirmations: _webComponents.renderer.loading()
      }, state, {
        isLoading: true,
        isConfirmationSaved: false
      });
    case _confirmations.CONFIRMATIONS.SAVE:
      {
        return _extends({
          confirmations: _webComponents.renderer.loading()
        }, state, {
          isLoading: true,
          isConfirmationSaved: false,
          saveConfirmationsStatus: _enum.status.SUBMITING
        });
      }
    case _confirmations.CONFIRMATIONS.FETCH_SUCCESS:
      {
        if (payload.confirmations.length > 0) {
          return _extends({}, state, {
            confirmations: _webComponents.renderer.success(payload.confirmations),
            confirmationsList: payload.confirmations,
            list: payload.confirmations,
            isLoading: false
          });
        }

        break;
      }
    case _confirmations.CONFIRMATIONS.FILTER.SET_SELECTED_DOCTORS:
      {
        if (payload.keys.length > 0) {
          var isSelectionChanged = !_lodash2.default.isEqual(state.selectedDoctors, payload.keys);

          return _extends({}, state, {
            isLoading: true,
            isFilterEmpty: false,
            selectedDoctors: payload.keys,
            selectedBranch: payload.selectedBranch,
            confirmations: isSelectionChanged ? _webComponents.renderer.loading() : _webComponents.renderer.success(state.confirmationsList)
          });
        }

        return _extends({}, state, {
          isFilterEmpty: true,
          selectedDoctors: [],
          confirmations: _webComponents.renderer.empty(payload.hasDoctors ? _confirmations3.default.EMPTY_FILTER : _confirmations3.default.NO_USERS)
        });
      }
    case _confirmations.CONFIRMATIONS.SAVE_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isConfirmationSaved: true,
          list: payload.confirmations,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'Changes applied successfully' : 'تمت التغييرات بنجاح'
          },
          saveConfirmationsStatus: _enum.status.SUCCESS
        });
      }

    case _confirmations.CONFIRMATIONS.SAVE_FAIL:
      {
        return _extends({}, state, {
          isLoading: false,
          isConfirmationSaved: false,
          snackBar: {
            show: true,
            message: _language.language === 'en' ? 'An Error has occurred' : 'لقد حدث خطاء ما'
          },
          saveConfirmationsStatus: _enum.status.FAIL
        });
      }

    case _confirmations.CONFIRMATIONS.SNACK_BAR.HIDE:
      return _extends({}, state, {
        snackBar: {
          show: false,
          message: ''
        }
      });
    default:
      return state;
  }

  return state;
};

module.exports = exports['default'];